/**
 * @module use-cases/user/actions
 * @desc User Action Creators
 *
 */

import type { Cart, User } from 'core/domains';
import type { BuyIntentionResponse } from 'core/services/bff';
import { createAsyncAction, createAction } from 'core/use-cases/utilities';

export const creditFetch = createAsyncAction<'creditFetch', undefined, User['credit']['data']>(
  'creditFetch',
);

export const userFetch = createAsyncAction<'userFetch', undefined, User['data']>('userFetch');

export const changeCycle = createAsyncAction<'changeCycle', { cycle: number }>('changeCycle');

export const cyclesFetch = createAsyncAction<
  'cyclesFetch',
  undefined,
  User['data']['avaliableCycles']
>('cyclesFetch');

export const setSearchInput = createAction<'setSearchInput', User['shippingModelSearch']>(
  'setSearchInput',
);

export const setSearchTracking = createAction<'setSearchTracking', User['shippingModelSearch']>(
  'setSearchTracking',
);

export const userBuyIntentionFetch = createAsyncAction<
  'userBuyIntention',
  {
    productCode: Cart['data']['items'][number]['productCode'];
    quantity: Cart['data']['items'][number]['quantity'];
    name: Cart['data']['items'][number]['name'];
  },
  BuyIntentionResponse,
  {
    productCode: Cart['data']['items'][number]['productCode'];
    quantity: Cart['data']['items'][number]['quantity'];
    name: Cart['data']['items'][number]['name'];
  }
>('userBuyIntention');

export const goToExtendedCycleSuccess = createAction<'goToExtendedCycleSuccess'>(
  'goToExtendedCycleSuccess',
);

export const updateCycle = createAction<'updateCycle'>('updateCycle');

export const userResaleIntention = createAsyncAction<
  'userResaleIntention',
  undefined,
  {
    isResaleIntention: boolean;
    isAutoStartEnabled: boolean;
  }
>('userResaleIntention');

export const userResetState = createAction<'userResetState'>('userResetState');

export const incentiveCampaignsListFetch = createAsyncAction<
  'incentiveCampaignsListFetch',
  undefined,
  User['incentiveCampaigns']['data']
>('incentiveCampaignsListFetch');
